var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "support_3249904 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0898 90.865C60.0898 87.4087 57.2879 84.6068 53.8316 84.6068H46.1684C44.5086 84.6068 42.9168 85.2662 41.7432 86.4398C40.5695 87.6134 39.9102 89.2052 39.9102 90.865C39.9102 94.3212 42.7121 97.1232 46.1684 97.1232H53.8316C57.2879 97.1232 60.0898 94.3212 60.0898 90.865ZM13.1564 74.7277C14.2018 74.8076 15.4664 74.8535 16.7367 74.7791C17.4135 78.2111 19.0947 81.3943 21.6043 83.9041C24.9359 87.2355 29.4545 89.1072 34.166 89.1072H36.5539C36.4486 89.6833 36.3945 90.2714 36.3945 90.865C36.3945 91.4652 36.4486 92.0529 36.5523 92.6228H34.166C28.5221 92.6228 23.1092 90.3808 19.1184 86.39C15.9346 83.206 13.8637 79.1171 13.1564 74.7277ZM11.3682 70.9869C8.59258 70.5189 6.00977 69.1994 3.99355 67.183C1.43652 64.6259 0 61.1578 0 57.5416V49.2324C0 45.6162 1.43652 42.148 3.99355 39.591C6.55059 37.0339 10.0187 35.5972 13.635 35.5972H14.5426C15.9934 17.2855 31.3141 2.87671 50 2.87671C68.6859 2.87671 84.0066 17.2855 85.4574 35.5972H86.365C89.9812 35.5972 93.4494 37.0339 96.0064 39.591C98.5635 42.148 100 45.6162 100 49.2324V57.5416C100 61.1578 98.5635 64.6259 96.0064 67.183C93.4494 69.7402 89.9812 71.1767 86.365 71.1767H82.3414C80.6727 71.1767 79.3199 69.8238 79.3199 68.1552V38.4466C79.3199 22.2537 66.193 9.12671 50 9.12671C33.807 9.12671 20.6801 22.2537 20.6801 38.4466V68.1552C20.6801 69.3333 20.0057 70.3542 19.0217 70.8525C16.3131 71.7923 12.1125 71.1124 11.3682 70.9869Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.8c89da3a07eb748166c78b900a9d3530.svg";
export { ForwardRef as ReactComponent };